module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [(_vm.configType) ? [_c('div', {
    staticClass: "wrap"
  }, [_c('section', {
    staticClass: "activity-bg"
  }, [_c('img', {
    attrs: {
      "src": _vm.configData.backgroundImage
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-topbox"
  }, [_c('div', {
    staticClass: "content-shareimg"
  }, [_c('share', {
    attrs: {
      "title": _vm.configData.title,
      "desc": _vm.configData.shareUrlTitle,
      "imgUrl": _vm.configData.shareUrlImage
    }
  })], 1), _vm._v(" "), _c('img', {
    staticClass: "content-logimg",
    attrs: {
      "src": _vm.configData.logoImage
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content-bottbox"
  }, [_c('div', {
    staticClass: "img-wrap"
  }, [_c('img', {
    attrs: {
      "src": _vm.configData.envelopeImage
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content-val"
  }, [_c('div', {
    staticClass: "input-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postData.phoneNum),
      expression: "postData.phoneNum"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请正确填写手机号"
    },
    domProps: {
      "value": (_vm.postData.phoneNum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.postData, "phoneNum", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postData.verifyCode),
      expression: "postData.verifyCode"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.postData.verifyCode)
    },
    on: {
      "focus": _vm.closeImg,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.postData, "verifyCode", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "login-get-code msg",
    on: {
      "click": function($event) {
        _vm.getImgCode()
      }
    }
  }, [_vm._v("获取验证码")])]), _vm._v(" "), _c('p', {
    staticClass: "content-button",
    on: {
      "click": function($event) {
        _vm.receiveGifts()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.configData.buttonImage
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "content-introduce",
    on: {
      "click": function($event) {
        _vm.showToast(true)
      }
    }
  }, [_vm._v("活动规则")])])])])]), _vm._v(" "), (_vm.iShow) ? _c('div', [_c('div', {
    staticClass: "toast-mask",
    staticStyle: {
      "display": "block"
    },
    on: {
      "click": function($event) {
        _vm.showToast(false)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "toast-body"
  }, [_vm._m(0), _vm._v(" "), _c('pre', {
    staticClass: "toast-msg"
  }, [_vm._v(_vm._s(_vm.configData.marketRule))])])]) : _vm._e()] : _vm._e(), _vm._v(" "), _c('img-code', {
    attrs: {
      "show": _vm.isShow,
      "phone": _vm.postData.phoneNum,
      "codeType": _vm.codeType
    },
    on: {
      "showOff": _vm.showOff
    }
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clearfix"
  }, [_c('p', {
    staticClass: "toast-title"
  }, [_vm._v("活动介绍")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-02750f7b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/treatment.vue
// module id = 126
// module chunks = 2